import Link from 'next/link';
import Head from 'next/head';

const ToolsServicesPage = () => {
  return (
    <>
      <Head>
        <title>Corporate-Design - Tools</title>
      </Head>

      <h1>Tools & Services</h1>
      <p className="lead">
        Mit Tools & Services sind im aktuellen Kontext zum rein internen
        Gebrauch entwickelte Applikationen der FHNW bezeichnet.
      </p>
      <p>
        Der vorliegende Styleguide soll es ermöglichen, für Tools & Services der
        FHNW einen einheitlichen, zum CD der FHNW-Webauftritte konsistenten
        visuellen Auftritt zu realisieren. Um dies ohne zusätzlichen
        Designaufwand zu gewährleisten, kann das vorliegende Framework genutzt
        werden. Insbesondere der Tools-Header steht hierbei als einheitliches
        Element inkl. Navigation und integrierter, vollständiger Wort-/Bildmarke
        der FHNW zur Verfügung. Elemente spezifisch für Tools & Services:
      </p>
      <ul>
        <li>
          <Link
            href={'/basic-elements/tools-header'}
            title={'Tools-Header'}
            legacyBehavior
          >
            <a>Tools-Header</a>
          </Link>
        </li>
        <li>
          <Link
            href={'/basic-elements/tools-footer'}
            title={'Tools-Footer'}
            legacyBehavior
          >
            <a>Tools-Footer</a>
          </Link>
        </li>
      </ul>

      <h2 className="mt-5">Hinweis</h2>
      <p>
        Der Webdienst-Header dient ausschliesslich zur Verwendung im Bereich
        Webdienste und ist nicht für den Einsatz im Kontext FHNW-Applikationen
        (Tools & Services) vorgesehen. Die CD-Vorgaben bezüglich Webdiensten
        sind unter dem entsprechenden Navigationspunkt erklärt. Technische
        Fragen bezogen auf die Implementation des Bootstrap-Frameworks können an{' '}
        <a href="mailto:webmaster@fhnw.ch">webmaster@fhnw.ch</a>
        gerichtet werden.
      </p>
    </>
  );
};

export default ToolsServicesPage;
